const direcciones = [
  {
    Id: 28,
    Nombre: "CEO"
  },
  {
    Id: 32,
    Nombre: "PROYECTOS"
  },
  {
    Id: 45,
    Nombre: "CAPITAL HUMANO"
  },
  {
    Id: 41,
    Nombre: "COMERCIAL"
  },
  {
    Id: 42,
    Nombre: "TECNOLOGIA"
  },
  {
    Id: 44,
    Nombre: "FINANCIERA"
  },
  {
    Id: 46,
    Nombre: "ADMINISTRACION y FINANZAS"
  },
  {
    Id: 49,
    Nombre: "OPERACIONES Y PROYECTOS"
  },
  {
    Id: 50,
    Nombre: "PROYECTOS"
  },
  {
    Id: 51,
    Nombre: "PLANIFICACION Y CALIDAD"
  },
  {
    Id: 52,
    Nombre: "OPERACIONES Y TECNOLOGIA"
  }
];

export default direcciones;
